import React from 'react';

import { setLoading } from '../../redux/loading/loadingActions';
import { Button, ModalContainer } from '../../elements';
import strings from '../../lang/lang';
import modal from './../../elements/ModalContainer/ModalContainer.module.scss';
import { appsActions, secretModalState, appDetailsData } from '../../redux/reducers/apps';
import { showError } from '../../elements/Toasts/toastActions';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';

function GenerateSecretModal(props) {
  const dispatch = useAppDispatch();
  const isVisibleSecretModal = useAppSelector(secretModalState);
  const data = useAppSelector(appDetailsData);
  const { id } = data;

  function regenerateNewSecret() {
    setLoading(true, true);
    return new Promise((res, rej) => {
      dispatch(appsActions.regenerateSecret({ appId: id, res, rej }));
    })
    .catch(() => {
      showError(strings.appCredentials.errors.regeneratingSecret);
    })
    .finally(() => {
      setLoading(false);
      dispatch(appsActions.toogleGenerateSecretModal(false));
    });
  }

  return (
    <ModalContainer
      isOpen={isVisibleSecretModal}
      closeModalWindow={() => dispatch(appsActions.toogleGenerateSecretModal(false))}
      title={strings.appCredentials.text.modalNewSecretTitle}
    >
      <div className={modal['react-modal__btn-box']}>
        <Button
          name={strings.appCredentials.buttons.generate}
          type="submit"
          variant="primary"
          secondaryClassName="popup_primary"
          onClick={() => regenerateNewSecret()}
        />
      </div>
      <Button
        name={strings.appCredentials.buttons.cancel}
        type="submit"
        variant="secondary"
        secondaryClassName="popup_secondary"
        onClick={() => dispatch(appsActions.toogleGenerateSecretModal(false))}
      />
    </ModalContainer>
  );
}

export default GenerateSecretModal;
